import React from 'react';
import { Link } from 'react-router-dom';

const PresaleList = props => {
    if (!props.presales) {
        return (
            <div>Loading...</div>
        );
    }

    if (props.presales.length === 0) {
        return (
            <div>
                No presales... yet.
      </div>
        );
    }

    return (
        <div>
            <table className="accountsTable">
                <thead>
                    <tr>
                        <th>Symbol</th>
                        <th>Event Name</th>
                        <th>Presale date</th>
                        {/* <th>Activation day increment</th> */}
                        <th>Presale amount</th>
                        {/* <th>Issue percentage</th> */}
                        <th>Issue complete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.presales.map(item => {
                            return (
                                <tr key={item.symbol}>
                                    <td>{item.symbol}</td>
                                    <td>{item.event_name}</td>
                                    <td>{item.presale_date}</td>
                                    {/* <td>{item.activation_day_increment}</td> */}
                                    <td>{item.presale_amount}</td>
                                    {/* <td>{item.issue_percentage}</td> */}
                                    <td>{item.issue_complete}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default PresaleList;



// WEBPACK FOOTER //
// ./src/components/widgets/PresaleList.js